import React from 'react';

import { Address } from '@/icons/index';
import { TickMark } from '@/components/SvgComponents/TickMark';

import styles from '../SearchList.module.scss';

interface Place {
  place_id: string;
  description: string;
}

interface SearchItemProps {
  place: Place;
  onSelect: (placeId: string, placeDescription: string) => void;
  isSelected: boolean;
}

const SearchItem: React.FC<SearchItemProps> = ({
  place,
  onSelect,
  isSelected,
}) => {
  const handleClick = () => {
    onSelect(place.place_id, place.description);
  };
  return (
    <li
      className={`${styles.searchItem} ${
        isSelected && styles.searchItem_active
      } `}
      onClick={handleClick}
      itemScope
      itemType='https://schema.org/ListItem'
    >
      <div className={styles.left}>
        <Address />
      </div>
      <div className={styles.right}>
        <span className={styles.txt}>{place.description}</span>
        {isSelected && <TickMark />}
      </div>
    </li>
  );
};

export default React.memo(SearchItem);
